import K_BannerLink from "../templates/K_BannerLink";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface BannerLinkOptions extends ComponentOptions {
    href: string;
    text: string;
    routerLink?: string;
}

export class BannerLink extends TemplateComponent {

    options: BannerLinkOptions;

    constructor(options: BannerLinkOptions) {
        super(K_BannerLink, options);
    }

    preRender() {
        const options = this.options;

        options.routerLink  = options.routerLink ? "router-link router-link-" + options.routerLink : "";
    }

    getContainer() {
        return $("#" + this.options.id + "_Container");
    }

    setActive() {
        this.get(".nav-bar-tab").addClass("active-module");
    }

    setInactive() {
        this.get(".nav-bar-tab").removeClass("active-module");
    }

    show() {
        this.getContainer().removeClass("hidden");
    }

    hide() {
        this.getContainer().addClass("hidden");
    }

}
